import { useLiveWireStore } from "@/stores/livewire";
import { useShallow } from "zustand/react/shallow";

const AppsReceivedTodayWidget = () => {

  const [daily] = useLiveWireStore(
    useShallow((state) => [state.daily])
  );

  return (
    <div className="new-app-counter widget widget-md">
      <div className="card card-rounded">
        <div className="d-flex justify-content-between p-3">
          <div>
            <span className="bi bi-inbox-fill text-orange me-2 fs-24"></span>
            <span className="text-black fw-bold fs-18">
              Apps Recieved Today
            </span>
          </div>
          <div className="px-2 py-1 fw-bold"></div>
        </div>
        <div className="card-body pt-0 d-flex justify-content-center align-items-center">
          <div className="widget-value">{daily?.apps_received}</div>
        </div>
      </div>
    </div>
  );
};

export default AppsReceivedTodayWidget;
